import { useEffect } from 'react';

// Une seule page de suppression de compte : /delete-account.html (déclarée sur
// les stores et liée depuis les applis), qui enregistre la demande en base.
export default function SupprimerCompte() {
  useEffect(() => {
    window.location.replace('/delete-account.html');
  }, []);
  return null;
}
